import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { PropsWithChildren, useCallback } from "react";
import { ModalLoading } from "./modal_loading";

import DynamicIcon from "./dynamic_icon";

/**
 * BaseListModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  title: string;
  onClose: () => void;
};

export const BaseListModal = ({
  open,
  saving,
  loading,
  title,
  children,
  onClose,
}: PropsWithChildren<Props>) => {

  const handleClose = useCallback(() => {
    if (!saving && !loading) onClose();
  }, [
    saving,
    loading,
    onClose
  ]);

  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            height: "90vh",
            maxWidth: "90vw",
          },
        },
      }}>
      <DialogTitle
        component="div"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
        <h2>{title}</h2>
        <div
          onClick={_ => handleClose()}>
          <DynamicIcon
            nameIcon="Close"
            size={25}
            className="text-black dark:text-white cursor-pointer"
          />
        </div>
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={saving}>
          {children}
        </ModalLoading>
      </DialogContent>
    </Dialog>
  );
}